/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Error_Wrong_PasswordInputs */

const de_auth_mfa_error_wrong_password = /** @type {(inputs: Auth_Mfa_Error_Wrong_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falsches Passwort. Bitte versuchen Sie es erneut.`)
};

/** @type {(inputs: Auth_Mfa_Error_Wrong_PasswordInputs) => LocalizedString} */
const en_auth_mfa_error_wrong_password = de_auth_mfa_error_wrong_password;

/**

* @param {Auth_Mfa_Error_Wrong_PasswordInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_error_wrong_password = /** @type {((inputs?: Auth_Mfa_Error_Wrong_PasswordInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Error_Wrong_PasswordInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_error_wrong_password(inputs)
	return en_auth_mfa_error_wrong_password(inputs)
});